module.exports = __webpack_public_path__ + "img/wushuju.d713ba13.png";